import {get} from "lodash";
import {IMAGES_URL} from "modules";
import {ISquad} from "modules/reducers";

interface IGetDisplayName {
	firstName: string;
	lastName: string;
}

export const getDisplayName = (player: IGetDisplayName, shortFirstName = false) => {
	if (shortFirstName) {
		return `${player.firstName}. ${player.lastName[0]}`;
	}

	return `${player.firstName} ${player.lastName}`;
};

export const nFormatter = (num: number, digits: number = 1, withoutCurrency: boolean = false) => {
	const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
	const currency = withoutCurrency ? "" : "$";
	const value = num ? (num / 1e6).toFixed(digits).replace(rx, "$1") + "m" : "0m";

	return `${currency}${value}`;
};

export const getSquadName = (squad?: ISquad) => {
	return get(squad, "abbr", "-");
};

export const getFantasySquadImage = (squad?: ISquad) => {
	if (!squad) {
		return "";
	}

	return `${IMAGES_URL}flags/${squad.abbr}.png`;
};

export const formatSelected = (value: number, digits: number = 1) => {
	return Number(value.toFixed(digits));
};
